export default __webpack_public_path__ + "static/media/WNo.5-1.3b5fae1e.jpg";